"use client";
// import momenttz from "moment-timezone";
import React from "react";
import dayjs from 'dayjs'; // Core Day.js
import utc from 'dayjs/plugin/utc.js'; // UTC plugin
import timezone from 'dayjs/plugin/timezone.js'; // Timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const MatchHistoryItem = ({ match, isHalftimeChecked }) => {
  const {
    matchTime,
    league,
    homeName,
    awayName,
    homeScore,
    awayScore,
    homeHalfScore,
    awayHalfScore,
    filterEuropeOdds,
    filterHandicapOdds,
    filterHandicapHalfOdds,
    europeResult,
    europeHalfResult,
    handiCapResult,
    handiCapHalfResult,
    overUnderResult,
    overUnderHalfResult,
  } = match;

  const finalScore = `${homeScore}-${awayScore}`;
  const halfScore = `${homeHalfScore}-${awayHalfScore}`;

  const europeOdds = isHalftimeChecked ? filterEuropeOdds : filterEuropeOdds;
  const handicapOdds = isHalftimeChecked
    ? filterHandicapHalfOdds
    : filterHandicapOdds;

  const handiCapResultData = isHalftimeChecked
    ? handiCapHalfResult
    : handiCapResult;

  const overUnderResultData = isHalftimeChecked
    ? overUnderHalfResult
    : overUnderResult;

  const matchTimeFormatted = dayjs
    .unix(matchTime)
    .tz("Asia/Ho_Chi_Minh")
    .format("DD/MM/YYYY");

  const renderBetResult = (result) => {
    if (result === -1) {
      return <span className="text-golden-yellow">B</span>;
    }

    if (result === 0) {
      return <span className="text-light-green-bet">H</span>;
    }

    if (result === 1) {
      return <span className="text-button-blue-bet dark:text-stroke-o3">T</span>;
    }

    return "-";
  };

  return (
    <div
      className={
        "w-full bg-white dark:bg-pure-black flex flex-row justify-center items-center  text-button-blue-bet dark:text-stroke-o3 p-[5px] gap-1 text-center text-xxs rounded"
      }
    >
      <div className={"w-1/12"}>{league?.shortName ?? ""}</div>
      <div className={"w-1/12"}>{matchTimeFormatted}</div>
      <div className={"w-2/12"}>{homeName}</div>
      <div className={"w-1/12"}>{`${finalScore}(${halfScore})`}</div>
      <div className={"w-2/12"}>{awayName}</div>
      <div className={"w-1/12"}>{match?.homeCorner}-{match?.awayCorner}</div>
      <div className={"w-3/12 flex flex-col gap-1"}>
        <div className={"flex flex-row justify-between items-center "}>
          <div className="flex-1 text-center">
            {renderOddValue(europeOdds?.home)}
          </div>
          <div className="flex-1 text-center">
            {renderOddValue(europeOdds?.draw)}
          </div>
          <div className="flex-1 text-center">
            {renderOddValue(europeOdds?.away)}
          </div>
          <div className="flex-1 text-center font-bold">
            {renderBetResult(
              isHalftimeChecked ? europeHalfResult : europeResult
            )}
          </div>
        </div>
      </div>
      <div className={"w-3/12 flex flex-col gap-1"}>
        <div className={"flex flex-row justify-between items-center "}>
          <div className="flex-1 text-center">
            {renderOddValue(handicapOdds?.home)}
          </div>
          <div className="flex-1 text-center">
            {renderOddValue(handicapOdds?.handicap)}
          </div>
          <div className="flex-1 text-center">
            {renderOddValue(handicapOdds?.away)}
          </div>
          <div className="flex-1 text-center font-bold">
            {renderBetResult(handiCapResultData)}
          </div>
        </div>
      </div>
      <div className={"w-1/12 text-center font-bold"}>
        {renderBetResult(overUnderResultData)}
      </div>
    </div>
  );
};

const renderOddValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  return value;
};

export default MatchHistoryItem;
